import axios from '../helpers/axios'
import { logError } from '../services';
import qs from 'querystring';
import {
  IPurchaseOrder,
  IPurchaseOrderDetails,
  IResponse,
  IInvalidPos,
  ISortDirection,
  IInvalidPosSort,
  ISelectableVendor
} from '../models';

export const getPurchaseOrders = async (filters?: {
  jobId?: number;
  taskId?: number;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
  partnerSageId?: number | string;
  orderTypeSageId?: number | string;
  statuses?: string[];
  search?: string;
}): Promise<IResponse<IPurchaseOrder[]>> => {
  try {
    const { data } = await axios.get(`/api/purchase-orders`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getPurchaseOrders failed');
    return Promise.reject(error);
  }
};

export const getPurchaseOrdersDetail = async (
  PurchaseOrderNumber
): Promise<IPurchaseOrderDetails | any> => {
  try {
    const { data } = await axios.get(`/api/purchase-orders/${PurchaseOrderNumber}`);
    return data;
  } catch (error: any) {
    logError(error, 'getPurchaseOrdersDetail failed');
    return error.response.data;
  }
};

export const getInvalidPos = async (filters?: {
  page?: number;
  perPage?: number;
  partnerSageId?: number;
  taskId?: number;
  jobId?: number;
  sortBy?: IInvalidPosSort;
  sortDirection?: ISortDirection;
}): Promise<IResponse<IInvalidPos[]>> => {
  try {
    const { data } = await axios.get(`/api/purchase-orders/invalid-purchase-orders`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getInvalidPos failed');
    return Promise.reject(error);
  }
};

export const getPurchaseOrderVendors = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
  name?: string;
}): Promise<IResponse<ISelectableVendor[]>> => {
  try {
    const { data } = await axios.get(`/api/purchase-orders/vendors`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getPurchaseOrderVendors failed');
    return Promise.reject(error);
  }
};
